<template>
  <b-modal v-model="localValue"
           :ok-title="$t('billing.generate')"
           ok-only
           :ok-disabled="!selectedResource || selectedDatePeriod.length < 7"
           @ok="onConfirm"
           :title="$t('billing.generate_invoices')">

    <loader v-if="loading"/>

    <b-row class="mb-3">
      <b-col>
        <label for="select-resource">{{ $t('billing.select_resource') }}</label>
        <multiselect
            v-model="selectedResource"
            id="select-resource"
            label="title"
            track-by="key"
            :placeholder="$t('billing.select_resource')"
            :options="resources"
            :searchable="true"
            :close-on-select="true"
            selectLabel=""
            selectedLabel="" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label for="select-period">{{ $t('billing.select_period') }}</label>
        <b-input v-model="selectedDatePeriod"
                 id="selected-period"
                 placeholder="YYYY-MM"
                 v-mask="'####-##'"/>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <label for="is-force" class="d-flex align-items-center">
          <b-form-checkbox type="checkbox"
                           id="is-force"
                           v-model="isForce" />
          <span class="ml-2">{{ $t('billing.double_invoices') }}</span>
        </label>

      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: "ModalGenerateInvoice",
  data() {
    return {
      selectedResource: '',
      selectedDatePeriod: '',
      loading: false,
      isForce: false
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        return this.$emit('input', value);
      }
    },
    resources() {
      const resources = this.$store.getters['resource/availableResources'];

      return  resources || [];
    }
  },
  methods: {
    onConfirm(event) {
      event.preventDefault();

      this.generateInvoices();
    },
    generateInvoices() {
      this.loading = true;

      let resource = '';
      if (this.selectedResource) {
        resource = this.selectedResource.key;
      }

      this.putData(`resources/${resource}/pricing/invoice/generate/monthly`, {
        is_force: this.isForce,
        calendar_period: this.selectedDatePeriod
      }).then(() => {
        this.localValue = false;
      }).finally(() => this.loading = false)
    }
  }
}
</script>
